import { h } from '@stencil/core';
export class AibaVtoHint {
  constructor() {
    this.data = undefined;
    this.vtoclass = 'showvto';
    this.handlers = undefined;
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.componentWillLoadVtoHint) {
      this.data = await this.handlers.componentWillLoadVtoHint(this.data);
    }
  }
  render() {
    return (h("div", { class: `vtoHintContainer ${this.vtoclass}` }, this.data &&
      this.data.elements.map((element) => {
        var _a, _b;
        if (element.name === 'aiba-icon') {
          return h("img", { src: (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.src, alt: (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.altText });
        }
      })));
  }
  static get is() { return "aiba-vto-hint"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-vto-hint.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-vto-hint.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "vtoclass": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "vtoclass",
        "reflect": false,
        "defaultValue": "'showvto'"
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-vto-hint.js.map
